// src/define-module.ts
function defineModule(module) {
  return module;
}

// src/enabled-modules.ts
function parse(csv) {
  const ids = (csv ?? "").split(",").map((id) => id.trim()).filter(Boolean);
  return ids.length > 0 ? ids : null;
}
function enabledModules(all, csv) {
  const known = new Set(all.map((module) => module.id));
  const duplicate = all.find(
    (module, index) => all.findIndex((m) => m.id === module.id) !== index
  );
  if (duplicate) {
    throw new Error(`Module id "${duplicate.id}" is registered twice.`);
  }
  const requested = parse(csv);
  if (requested) {
    const unknown = requested.filter((id) => !known.has(id));
    if (unknown.length > 0) {
      throw new Error(
        `Unknown module(s) in the enabled list: ${unknown.join(", ")}. Known modules: ${[...known].join(", ") || "(none)"}.`
      );
    }
  }
  const enabled = requested ? all.filter((module) => requested.includes(module.id)) : [...all];
  const enabledIds = new Set(enabled.map((module) => module.id));
  for (const module of enabled) {
    const missing = (module.requires ?? []).filter((id) => !enabledIds.has(id));
    if (missing.length > 0) {
      throw new Error(
        `Module "${module.id}" requires ${missing.join(", ")}, which is not enabled.`
      );
    }
  }
  return enabled;
}

// src/events.ts
function defineEvent(name) {
  return { name };
}

// src/group-nav.ts
function groupNav(items, order = []) {
  const byGroup = /* @__PURE__ */ new Map();
  for (const item of items) {
    const bucket = byGroup.get(item.group);
    if (bucket) {
      bucket.push(item);
    } else {
      byGroup.set(item.group, [item]);
    }
  }
  const known = order.filter((title) => byGroup.has(title));
  const extra = [...byGroup.keys()].filter((title) => !order.includes(title));
  return [...known, ...extra].map((title) => ({
    title,
    items: byGroup.get(title) ?? []
  }));
}

export { defineEvent, defineModule, enabledModules, groupNav };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map